import React from "react";
import { Fallback } from "./fallback";

class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    // 다음 렌더링에서 폴백 UI를 표시하도록 상태를 업데이트
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // 에러 로깅 (예: Sentry, LogRocket 등을 활용 가능)
    console.error("ErrorBoundary caught an error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // 사용자 친화적인 에러 메시지 UI
      return <Fallback />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
